import { LegalLayout } from './LegalLayout';

interface Sub {
  name: string;
  purpose: string;
  region: string;
  transferMechanism: string;
}

const SUBS: Sub[] = [
  {
    name: 'Microsoft Azure (West Europe / North Europe)',
    purpose: 'Compute, storage, database hosting, Document Intelligence OCR',
    region: 'EU (Netherlands + Ireland)',
    transferMechanism: 'Intra-EEA — no transfer',
  },
  {
    name: 'Google Cloud (Gemini API)',
    purpose: 'Primary AI model for extraction, classification, coding',
    region: 'EU region (europe-west4) where available, otherwise US',
    transferMechanism: 'SCCs (2021/914/EU) Module 3 + enterprise no-training terms',
  },
  {
    name: 'Anthropic (Claude API)',
    purpose: 'Fallback AI model for high-reasoning extraction tasks',
    region: 'US (Anthropic does not yet offer EU residency)',
    transferMechanism: 'SCCs + TIA + no-training enterprise terms',
  },
  {
    name: 'OpenAI',
    purpose: 'Fallback AI model + text embeddings (for semantic search)',
    region: 'US with EU processing enclave when available',
    transferMechanism: 'SCCs + enterprise data-residency where supported',
  },
  {
    name: 'Stripe Payments Europe Ltd',
    purpose: 'Payment processing, billing, invoicing',
    region: 'EU (Ireland)',
    transferMechanism: 'Stripe DPA, Stripe SCCs for out-of-EEA transfers',
  },
  {
    name: 'SendGrid / Postmark (email)',
    purpose: 'Transactional email (invitations, password resets, notifications)',
    region: 'EU region used where available',
    transferMechanism: 'SCCs + enterprise DPA',
  },
  {
    name: 'Sentry.io',
    purpose: 'Error tracking + performance monitoring (errors only, PII scrubbed)',
    region: 'EU (Frankfurt) — selected on account setup',
    transferMechanism: 'Intra-EEA when EU region selected',
  },
  {
    name: 'GitHub (for source code)',
    purpose: 'Source code repository, CI/CD',
    region: 'US',
    transferMechanism: 'No Controller personal data processed; internal-use only',
  },
];

export function SubprocessorsPage() {
  return (
    <LegalLayout title="Sub-processor list" lastUpdated="2026-04-22">
      <p className="lead">
        Praxara uses the sub-processors listed below to deliver the Service.
        We notify Controllers at least 14 days before onboarding a new
        sub-processor and any Controller may object on reasonable grounds.
      </p>

      <table className="legal-table">
        <thead>
          <tr>
            <th>Sub-processor</th>
            <th>Purpose</th>
            <th>Region</th>
            <th>Transfer mechanism</th>
          </tr>
        </thead>
        <tbody>
          {SUBS.map((s) => (
            <tr key={s.name}>
              <td>{s.name}</td>
              <td>{s.purpose}</td>
              <td>{s.region}</td>
              <td>{s.transferMechanism}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="mt-6 text-sm text-muted-foreground">
        SCCs = Standard Contractual Clauses (EU Commission Decision 2021/914/EU).
        TIA = Transfer Impact Assessment.
      </p>
    </LegalLayout>
  );
}
